var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { spacingCss } from "../../global/css";
export var StyledImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var size = _a.size;
    return "\n    width: " + size + "px;\n    height: " + size + "px;\n  ";
});
export var ImageContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  ", "\n  width: 100%;\n  ", "\n"], ["\n  position: absolute;\n  ", "\n  width: 100%;\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return "top: -" + ((size / 2) + 5) + "px;";
}, spacingCss);
export var OuterContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var size = _a.size;
    return "\n    width: " + size + "px;\n  ";
});
var templateObject_1, templateObject_2, templateObject_3;
